module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/asti.10a7a6eee656fb7fd44c50608fc6a744.jpg";